function bindSwatchSelection() {
  const checkboxes = document.querySelectorAll(".custom-radio .checkbox");

  checkboxes.forEach((checkbox) => {
    checkbox.addEventListener("change", function () {
      const label = document.querySelector(`label[for="${checkbox.id}"]`);

      if (!label) return;

      const swatch = label.querySelector(".color-swatch");

      if (!swatch) return;

      if (checkbox.checked) {
        swatch.classList.add("swatch-selected");
      } else {
        swatch.classList.remove("swatch-selected");
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", function () {
  bindSwatchSelection();
  updateAccordionBorders();
});

document.addEventListener("shown.bs.collapse", updateAccordionBorders);
document.addEventListener("hidden.bs.collapse", updateAccordionBorders);

function updateAccordionBorders() {
  const allItems = document.querySelectorAll("#product-filter .accordion-item");

  // Reset all states
  allItems.forEach((item) => {
    item.classList.remove("accordion-open", "accordion-prev");
  });

  // Loop through all items
  allItems.forEach((item) => {
    const collapse = item.querySelector(".accordion-collapse");

    if (collapse && collapse.classList.contains("show")) {
      item.classList.add("accordion-open");
      let prev = item.previousElementSibling;
      while (prev && !prev.classList.contains("accordion-item")) {
        prev = prev.previousElementSibling;
      }
      if (prev) {
        prev.classList.add("accordion-prev");
      }
    }
  });
}
